import { z } from 'zod';
import { loanIdSchema, methodSchema, phoneNumberSchema, requestIdSchema, smsIdSchema, providerType, } from '@repo/shared/types';
import { internalErrorResponseSchema, loanDataNotFoundResponseSchema, loanResponseBaseSchema, redisKeyNotFoundResponseSchema, } from './loan-shared.schema';
export var loanSignRequestBodySchema = z.object({
    requestId: requestIdSchema,
    loanId: loanIdSchema,
    provider: providerType,
    phoneNumber: phoneNumberSchema.nullable(),
});
// Response code 200
export var loanSignPragmaSuccessResponseBodySchema = loanResponseBaseSchema.and(z.object({
    data: z.object({
        loanId: loanIdSchema,
        method: methodSchema,
        smsId: smsIdSchema,
        phoneNumber: phoneNumberSchema,
        attempt: z.number().nonnegative(),
    }),
}));
// Response code 200
export var loanSignLiberisSuccessResponseBodySchema = loanResponseBaseSchema.and(z.object({
    data: z.object({
        loanId: loanIdSchema,
        method: methodSchema,
        url: z.string().url(),
    }),
}));
// Response code 400
export var loanSignRedisKeyNotFoundResponseBodySchema = redisKeyNotFoundResponseSchema;
// Response code 404
export var loanSignNotFoundResponseBodySchema = loanDataNotFoundResponseSchema;
// Response code 429 - Too many attempts - They're the same 404 and 429 schema
export var loanSignTooManyAttemptsResponseBodySchema = loanDataNotFoundResponseSchema;
// Response code 500
export var loanSignInternalErrorResponseBodySchema = internalErrorResponseSchema;
